module.exports = __webpack_public_path__ + "static/media/western-logo.a4a53641.png";